import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["name", "version", "extension", "verticalAlign", "alt"];
import React, { forwardRef } from 'react';
import { getLogo } from '../../system';
import Image from '../Image'; // Passed to Image

var SYSTEM_PROPS = ['borderRadiusProps', 'flexProps', 'floatProps', 'heightProps', 'marginProps', 'positioningProps', 'widthProps'];

var normalizeName = function normalizeName(name) {
  if (name && name.includes('.')) {
    return {
      scope: name.split('.')[0],
      name: name.split('.')[1]
    };
  }

  return {
    scope: undefined,
    name: name
  };
};

var Logo = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
      version = _ref.version,
      extension = _ref.extension,
      verticalAlign = _ref.verticalAlign,
      alt = _ref.alt,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var obj = normalizeName(name);
  var logo = getLogo(obj.name, obj.scope, version);

  if (logo[extension]) {
    return /*#__PURE__*/React.createElement(Image, _extends({}, rest, {
      ref: ref,
      src: logo[extension] + "?v=" + (version || 1),
      verticalAlign: verticalAlign,
      alt: alt || logo.alt
    }));
  }

  return null;
});
Logo.displayName = 'Logo';
Logo.identifier = Logo.displayName; // used in docs website

Logo.clonableProps = SYSTEM_PROPS;
Logo.defaultProps = {
  extension: 'svg',
  verticalAlign: 'middle'
};
export default Logo;